// modules
import { createAction } from 'redux-actions'

export const setProviderPortalList = createAction('SET_PROVIDER_PORTAL_LIST')
export const setProviderPortalLoading = createAction(
  'SET_PROVIDER_PORTAL_LOADING'
)
export const setProviderPortalItem = createAction('SET_PROVIDER_PORTAL_ITEM')

export const setProviderPortalModalClinicians = createAction(
  'SET_PROVIDER_PORTAL_MODAL_CLINICIANS'
)

export const resetProviderPortal = createAction('RESET_PROVIDER_PORTAL')
